module.exports = __webpack_public_path__ + "img/health_status_icon1.a4049366.png";